import * as React from 'react'
import { connect } from 'react-redux'

import { Checkbox, CheckboxType } from 'components/Checkboxes'
import { Grid, GridGap } from 'components/Grid'
import { actions as formActions } from 'react-redux-form'
import { City } from '../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import { getMaxIncludedCities } from '../../data/models/funnelOrder/includedCities'
import { Theme } from '../../data/models/funnelOrder/theme'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import DisplayContent from '../../pages/shared/content'
import * as actions from '../../store/actions'
import { IncludeCitiesOptions } from '../../store/funnelOrder/themeCities/types'

interface FlyIncludedCitiesCheckboxStateProps {
  theme: Theme
  country: SiteCountry
  excludedCities: City[]
  themeCities: IncludeCitiesOptions[]
}

export interface FlyIncludedCitiesCheckboxDispatchProps {
  getThemeCities(): void
  setIncludedCities(value: City[]): void
}

export interface FlyIncludedCitiesCheckboxOwnProps {
  destination: destinationEnum
  max?: number
  solid?: boolean
}

export interface FlyIncludedCitiesCheckboxProps
  extends FlyIncludedCitiesCheckboxStateProps,
    FlyIncludedCitiesCheckboxDispatchProps,
    FlyIncludedCitiesCheckboxOwnProps {}

class FlyIncludedCitiesCheckbox extends React.Component<
  FlyIncludedCitiesCheckboxProps
> {
  public componentDidMount() {
    const { getThemeCities } = this.props
    getThemeCities()
  }

  public componentDidUpdate(props: FlyIncludedCitiesCheckboxProps) {
    const { country, getThemeCities } = this.props
    if (props.country !== country) {
      getThemeCities()
    }
  }

  public render() {
    const { themeCities, excludedCities } = this.props
    const max = this.getMaxCityItems()

    return (
      <Grid nrCols={[2, 3]} colGap={[GridGap.m]} rowGap={[GridGap.m]}>
        {themeCities.map(city => {
          return (
            <Checkbox
              name={`exclude-${city.value}`}
              checkboxType={CheckboxType.Box}
              key={`${city.value}`}
              value={`${city.value}`}
              disabled={
                excludedCities.length >= max &&
                !this.isCityIncluded(excludedCities, city)
              }
              checked={!this.isCityIncluded(excludedCities, city)}
              onChange={this.handleChange}
            >
              <DisplayContent
                addNode
                edit={true}
                contentKey={`choice-${city.label}`}
              >
                {city.label}
              </DisplayContent>
            </Checkbox>
          )
        })}
      </Grid>
    )
  }

  private isCityIncluded = (cities: City[], city: IncludeCitiesOptions) => {
    return city.value ? cities.map(x => x.id).includes(+city.value) : []
  }

  private handleChange = (value: string, checked: boolean) => {
    const { excludedCities, themeCities } = this.props

    const excludedCitiesList = [...excludedCities]
    const filteredCities = themeCities.filter(
      x => x.value && +x.value === +value,
    )
    const city = filteredCities.length > 0 ? filteredCities[0] : null

    if (city !== null) {
      if (this.isCityIncluded(excludedCitiesList, city) && checked) {
        const index = excludedCitiesList.map(x => x.id).indexOf(+city.value)
        excludedCitiesList.splice(index, 1)
      }
      if (!this.isCityIncluded(excludedCitiesList, city) && !checked) {
        excludedCitiesList.push({
          id: +city.value,
          name: city.label,
        })
      }

      this.props.setIncludedCities(excludedCitiesList)
    }
  }

  private getMaxCityItems = () => {
    const { max } = this.props
    return max || getMaxIncludedCities()
  }
}

export default connect<
  FlyIncludedCitiesCheckboxStateProps,
  FlyIncludedCitiesCheckboxDispatchProps,
  FlyIncludedCitiesCheckboxOwnProps,
  AppState
>(
  state => ({
    theme: state.funnelOrder.theme,
    country: state.locale.country,
    excludedCities: state.funnelOrder.excludedCitiesIds,
    themeCities: state.funnelOrder.themeCities.data,
  }),
  dispatch => ({
    getThemeCities: () => dispatch(actions.funnelOrderThemeCitiesGetRequest()),
    setIncludedCities: (cities: City[]) =>
      dispatch(formActions.change('funnelOrder.excludedCitiesIds', cities)),
  }),
)(FlyIncludedCitiesCheckbox)
